import React from 'react';

const FormattedTime = ({ seconds }) => {
  if (seconds === undefined || seconds === null) {
    return (
      <span>
        0:00<span style={{ fontSize: '0.7em' }}>.000</span>
      </span>
    );
  }
  const totalSeconds = Math.floor(seconds);
  const milliseconds = Math.floor((seconds - totalSeconds) * 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const remainingSeconds = totalSeconds % 60;

  if (hours > 0) {
    return (
      <span>
        {hours}:{minutes < 10 ? '0' : ''}{minutes}:{remainingSeconds < 10 ? '0' : ''}{remainingSeconds}
        <span style={{ fontSize: '0.7em' }}>.{milliseconds.toString().padStart(3, '0')}</span>
      </span>
    );
  }
  return (
    <span>
      {minutes}:{remainingSeconds < 10 ? '0' : ''}{remainingSeconds}
      <span style={{ fontSize: '0.7em' }}>.{milliseconds.toString().padStart(3, '0')}</span>
    </span>
  );
};

export default FormattedTime;
